import { createFileRoute } from '@tanstack/react-router'

import EditApbnApbdPage from '@/components/pages/backoffice/_ktg-penyuluh/apbn-apbd/$apbnApbd/_edit/containers/EditApbnApbdPage'

export const Route = createFileRoute(
  '/_backoffice/ktg-penyuluh/apbd/$apbdId/edit/'
)({
  component: RouteComponent
})

function RouteComponent() {
  const id = Route.useParams().apbdId
  return <EditApbnApbdPage type="APBD" id={id} />
}
